import * as React from 'react';
import { SVGProps } from 'react';

const IconRulerFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 7h-3v4h-2V7H8v3H6V7H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-3v3h-2V7Z" />
  </svg>
);
export default IconRulerFilledSizeM;
